/**
 *
 * SelectCountry
 *
 */

import React from 'react'
import PropTypes from 'prop-types'
import { CountryList } from 'app/views/constants';

const propTypes = {
  onCountryChange: PropTypes.func,
}

const SelectCountry = ({ currentCountry, onCountryChange }) => {
  return (
    <select
      className="uk-select"
      name="country"
      onChange={e => onCountryChange(e.target.value)}
      defaultValue={currentCountry}
    >
      {CountryList.map(country => (
        <option value={country} key={country}>{country}</option>
      ))}
    </select>
  )
}

SelectCountry.propTypes = propTypes

export default SelectCountry